/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiAIPromptType;
(function (ApiAIPromptType) {
    ApiAIPromptType["AI_PROMPT_TYPE_ROUTER"] = "AIPromptTypeRouter";
    ApiAIPromptType["AI_PROMPT_TYPE_SERVICE"] = "AIPromptTypeService";
    ApiAIPromptType["AI_PROMPT_TYPE_CHART"] = "AIPromptTypeChart";
    ApiAIPromptType["AI_PROMPT_TYPE_ANALYST"] = "AIPromptTypeAnalyst";
    ApiAIPromptType["AI_PROMPT_TYPE_PLANNER"] = "AIPromptTypePlanner";
    ApiAIPromptType["AI_PROMPT_TYPE_SUMMARY"] = "AIPromptTypeSummary";
    ApiAIPromptType["AI_PROMPT_TYPE_FINAL_SUMMARY"] = "AIPromptTypeFinalSummary";
    ApiAIPromptType["AI_PROMPT_TYPE_LANDING_PAGE"] = "AIPromptTypeLandingPage";
    ApiAIPromptType["AI_PROMPT_TYPE_REVIEWER"] = "AIPromptTypeReviewer";
    ApiAIPromptType["AI_PROMPT_TYPE_SIMPLE_ANALYST"] = "AIPromptTypeSimpleAnalyst";
    ApiAIPromptType["AI_PROMPT_COMPONENT_BLOCK"] = "AIPromptComponentBlock";
    ApiAIPromptType["AI_PROMPT_IMAGE_GENERATION"] = "AIPromptImageGeneration";
    ApiAIPromptType["AI_PROMPT_IMAGE_EDITING"] = "AIPromptImageEditing";
    ApiAIPromptType["AI_PROMPT_IMAGE_GENERATION_CONTEXT"] = "AIPromptImageGenerationContext";
    ApiAIPromptType["AI_PROMPT_IMAGE_EDITING_CONTEXT"] = "AIPromptImageEditingContext";
    ApiAIPromptType["AI_PROMPT_TYPE_LANDING_COMPONENT"] = "AIPromptTypeLandingComponent";
    ApiAIPromptType["AI_PROMPT_TYPE_LANDING_BLOCK"] = "AIPromptTypeLandingBlock";
    ApiAIPromptType["AI_PROMPT_TYPE_MCP_AGENT"] = "AIPromptTypeMCPAgent";
})(ApiAIPromptType || (ApiAIPromptType = {}));
export function ApiAIPromptTypeFromJSON(json) {
    return ApiAIPromptTypeFromJSONTyped(json, false);
}
export function ApiAIPromptTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiAIPromptTypeToJSON(value) {
    return value;
}
